<div class="p-5 background">
    <div class="page">
        <img class="header-img" src="https://cdn.nepta.dev/site/templates/header-contratto.png">
        <div class="text-body-pdf m-1" [innerHTML]="transform(text)"></div>
        <img class="footer-img" src="https://cdn.nepta.dev/site/templates/footer-contratto.png">
    </div>
</div>
